<template>
  <div class="list-hrm-sync-page">
    <KTCodePreview v-bind:title="'Trạng thái đồng bộ HRM'">
      <template v-slot:toolbar> </template>
      <template v-slot:preview>
        <!-- Header session -->
        <!-- tag-->
        <b-row class="mb-5">
          <b-col md="3">
            <div class="search-col">
              <date-picker
                placeholder="Từ ngày"
                class="form-control-sm"
                :config="dpConfigs.date"
                v-model="params.fromDate"
              ></date-picker>
              <span class="ml-1 mr-1"></span>
              <date-picker
                placeholder="Đến ngày"
                class="form-control-sm"
                :config="dpConfigs.date"
                v-model="params.toDate"
              ></date-picker>
            </div>
          </b-col>
          <b-col md="3">
            <b-form-input
              v-model.trim="params.referenceId"
              type="text"
              placeholder="ID tham chiếu"
              size="sm"
              v-on:keyup.enter="onFilter()"
            ></b-form-input>
          </b-col>
          <b-col md="3">
            <b-form-select
              value-field="id"
              text-field="name"
              v-model="params.module"
              :options="listHRMSyncModule"
              size="sm"
            >
              <template #first>
                <b-form-select-option :value="null"
                  >-- Lọc theo module --</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-col>
          <b-col md="3">
            <b-form-select
              value-field="id"
              text-field="name"
              v-model="params.status"
              :options="syncStatusOptions"
              size="sm"
            >
              <template #first>
                <b-form-select-option :value="null"
                  >-- Trạng thái --</b-form-select-option
                >
              </template>
            </b-form-select>
          </b-col>
        </b-row>
        <!--end tag-->
        <b-row class="mb-5">
          <b-col md="1">
            <b-button
              variant="primary"
              size="sm"
              class="btn font-weight-bold btn-size"
              @click="fetchData()"
              :disabled="onLoading"
              >Lọc</b-button
            >
          </b-col>
        </b-row>
        <b-nav class="my-3" tabs pills> </b-nav>
        <!-- End of Header session -->
        <!-- Table session -->
        <b-table
          :items="listHrmSyncStatus"
          :fields="fields"
          bordered
          hover
          :busy="onLoading"
        >
          <template v-slot:table-busy>
            <vcl-table :speed="5" :animate="true" :columns="10"></vcl-table>
          </template>
          <template v-slot:cell(status)="row">
            <span
              v-text="STATUS_CODE_NAME[row.item.status]"
              class="label font-weight-bold label-lg label-inline mb-2"
              :class="statusNameClasses(row.item.status)"
              style="width: max-content"
            ></span>
          </template>
          <template v-slot:cell(moduleName)="row">
            <span>{{ moduleNameMap[row.item.module] }}</span>
          </template>
          <template v-slot:cell(createdAt)="row">
            <span>{{ formatDate(row.item.createdAt, CLIENT_DATE_TIME) }}</span>
          </template>
          <template v-slot:cell(updatedAt)="row">
            <span>{{ formatDate(row.item.updatedAt, CLIENT_DATE_TIME) }}</span>
          </template>
          <template v-slot:cell(actions)="row">
            <div class="d-flex justify-content-center">
              <b-dropdown size="sm" id="dropdown-left" no-caret right>
                <template slot="button-content">
                  <i class="flaticon2-settings"></i>
                </template>
                <b-dropdown-item @click="showDetailError(row.item)">
                  <span style="color: #3f4254; font-size: 10px">
                    <i class="flaticon-eye"></i>
                    &nbsp; Chi tiết
                  </span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="row.item.status === STATUS_CODE.ERROR"
                  @click="retrySyncItem(row.item)"
                >
                  <span style="color: #3f4254; font-size: 10px">
                    <i class="fa-solid fa-paper-plane icon-size"></i>
                    &nbsp; Đồng bộ lại
                  </span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </template>
        </b-table>
        <!-- End of Table session -->

        <!-- Paginate session -->
        <b-row>
          <b-col>
            <p class="mt-3 text-dark font-weight-bold">
              Tổng:
              {{ totalItems }}
            </p>
          </b-col>
          <b-col>
            <BPaginationNavCustom
              :number-of-pages="totalPages || 1"
              :current-page="page"
              :total-page="totalPages"
              :linkParams="{}"
              @page-change="fetchData()"
            >
            </BPaginationNavCustom>
          </b-col>
        </b-row>
        <!-- End of Paginate session -->

        <!-- HRM Sync Detail Modal -->
        <HRMSyncDetailModal
          ref="hrm-sync-detail-modal"
          :hrm-sync-status="previewDetail"
          :mode="modalMode"
          @retry-success="onRetrySuccess"
          @modal-hidden="onModalHidden"
          @mode-changed="onModeChanged"
        />
      </template>
    </KTCodePreview>
  </div>
</template>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import ApiService from '@/core/services/api.service';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import { VclTable } from 'vue-content-loading';
import 'vue-cute-timeline/dist/index.css';
import {
  DP_CONFIG,
  getSubtractDate,
  formatDate,
  CLIENT_DATE_TIME,
} from '@/utils/date';
import BPaginationNavCustom from '@/view/base/bootstrap/BPaginationNavCustom.vue';
import { STATUS_CODE } from '@/utils/enum';
import { STATUS_CODE_NAME } from '@/utils/enum-name';
import { formatDBDate } from '../../../utils/date';
import HRMSyncDetailModal from '@/view/components/hrm-sync/HRMSyncDetailModal.vue';
import { handleError } from '@/utils/common';

export default {
  data() {
    return {
      page: 1,
      listHRMSyncModule: [],
      onLoading: false,
      listHrmSyncStatus: [],
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
        },
        {
          key: 'referenceId',
          label: 'ID tham chiếu ',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
        },
        {
          key: 'moduleName',
          label: 'Tên module ',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          tdClass: 'font-weight-bold',
        },
        {
          key: 'status',
          label: 'Trạng thái',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          tdClass: 'text-center',
        },
        {
          key: 'createdAt',
          label: 'Thời gian tạo',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '15%' },
          tdClass: 'text-right',
        },
        {
          key: 'response',
          label: 'Kết quả',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'retryResponse',
          label: 'Kết quả thử lại',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32' },
        },
        {
          key: 'actions',
          label: '',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
        },
      ],
      linkGen: (pageNum) => {
        return pageNum === 1 ? '?' : `?page=${pageNum}`;
      },
      dpConfigs: DP_CONFIG,
      params: {
        fromDate: getSubtractDate(15),
        toDate: null,
        status: null,
        module: null,
        referenceId: '',
      },
      totalItems: 0,
      totalPages: 1,
      CLIENT_DATE_TIME: CLIENT_DATE_TIME,
      STATUS_CODE_NAME,
      STATUS_CODE,
      syncStatusOptions: Object.entries(STATUS_CODE).map(([key, value]) => ({
        id: value,
        key,
        name: STATUS_CODE_NAME[value],
      })),
      previewDetail: {
        payload: null,
        url: null,
        method: null,
        createdAt: null,
        updatedAt: null,
        retryResponse: null,
        response: null,
        retryPayload: null,
      },
      modalMode: 'view', // 'view' or 'retry'
      moduleNameMap: {},
    };
  },
  methods: {
    formatDate,
    async fetListHrmSyncModule() {
      const {
        data: { data },
      } = await ApiService.get('hrm-sync/sync-module');
      this.listHRMSyncModule = data;
      this.moduleNameMap = data.reduce((acc, item) => {
        acc[item.id] = item.name;
        return acc;
      }, {});
    },
    async onFilter() {
      this.$route.query.page = 1;
      this.fetchData();
    },
    async fetchData() {
      try {
        if (this.onLoading) return;
        this.onLoading = true;
        const params = this.getParamsFilter();
        const {
          data: { data },
        } = await ApiService.query('hrm-sync/status', { params });
        this.listHrmSyncStatus = data.result;
        this.totalItems = data.totalItems;
        this.totalPages = data.totalPages;
      } catch (error) {
        await handleError(error);
      } finally {
        this.onLoading = false;
      }
    },
    getParamsFilter() {
      return {
        ...this.params,
        fromDate: formatDBDate(this.params.fromDate),
        toDate: formatDBDate(this.params.toDate),
      };
    },
    statusNameClasses(status) {
      const statusClassMapping = {
        [STATUS_CODE.ERROR]: 'label-light-danger',
        [STATUS_CODE.SUCCESS]: 'label-light-success',
      };
      return statusClassMapping[status] || 'label-light-info';
    },

    showDetailError(item) {
      this.previewDetail = { ...item };
      this.modalMode = 'view';
      this.$refs['hrm-sync-detail-modal'].showModal();
    },

    retrySyncItem(item) {
      this.previewDetail = { ...item };
      this.modalMode = 'retry';
      this.$refs['hrm-sync-detail-modal'].showModal();
    },

    onRetrySuccess(item) {
      const foundIndex = this.listHrmSyncStatus.findIndex(
        ({ id }) => id === item.id,
      );
      if (foundIndex !== -1) {
        const updatedItem = { ...this.listHrmSyncStatus[foundIndex], ...item };
        this.listHrmSyncStatus.splice(foundIndex, 1, updatedItem);
        this.previewDetail = updatedItem;
      }
    },

    onModalHidden() {
      this.modalMode = 'view';
    },

    onModeChanged(mode) {
      this.modalMode = mode;
    },
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Danh sách trạng thái đồng bộ', route: 'hrm-sync' },
      { title: 'Danh sách trạng thái đồng bộ' },
    ]);
  },
  created() {
    this.fetchData();
    this.fetListHrmSyncModule();
  },
  computed: {},
  components: {
    KTCodePreview,
    VclTable,
    BPaginationNavCustom,
    HRMSyncDetailModal,
  },
};
</script>

<style scoped>
.btn-size {
  width: 90px;
}

.icon-size {
  font-size: 1rem;
}

.nav .nav-link {
  color: #3f4254;
  font-weight: 800;
}

.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}

input:focus {
  outline: none !important;
  border: 1px solid #92c5f9;
}

select {
  height: 2.5em;
}

code,
pre {
  margin: 1em 0;
  padding: 1em;
  border: 1px solid #bbb;
  display: block;
  background: #ddd;
  border-radius: 3px;
}

.settings {
  margin: 2em 0;
  border-top: 1px solid #bbb;
  background: #eee;
}

.form-group {
  margin-bottom: 1em;
}

.btn.btn-icon.btn-sm,
.btn-group-sm > .btn.btn-icon {
  height: calc(1.35em + 1.1rem + 2px);
  width: auto;
}

.icon:hover {
  background-color: #90c6fc;
}

::-webkit-datetime-edit-year-field:not([aria-valuenow]),
::-webkit-datetime-edit-month-field:not([aria-valuenow]),
::-webkit-datetime-edit-day-field:not([aria-valuenow]) {
  color: transparent;
}

.search-col {
  display: flex;
  align-items: center;
}
</style>
<style lang="scss" scoped></style>
